import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';
import { loadSurveyResponse } from '../../employees/actions/survey/load-survey-response';

import * as Api from '../../api/api';

export const retryMessage = (messageId: number, context?: { surveyResponseId?: number }) =>
  createGenericDispatcher({
    name: 'RETRY_MESSAGE',
    loadFunction: () =>
      Api.post(`/message/${messageId}`, {
        body: JSON.stringify({ retryMessage: true }),
      }),
    args: { messageId },
    onSuccess: (dispatch: Function) => {
      if (context && context.surveyResponseId) {
        dispatch(loadSurveyResponse(context.surveyResponseId));
      }
      dispatch(
        addNotificationAction({
          key: `retry-message-notification-${messageId}`,
          message: 'Message was sent successfully',
        }),
      );
    },
  });
